import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';

import GuestLayout from '../../layouts/guest';
import useStyles from './styles';

const NotFound: React.FunctionComponent = () => {
  const css = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <GuestLayout>
      <Container className={css.container}>
        <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <h1 data-testid="not-found-title" className="title">
              {t('notFound.title')}
            </h1>
            <h2 data-testid="not-found-error" className="title">
              {t('notFound.error')}
            </h2>
            <div data-testid="not-found-message" className={css.message}>
              {t('notFound.message')}
            </div>
            <div className={css.actions}>
              <Link
                component="button"
                variant="button"
                data-testid="not-found-back"
                onClick={history.goBack}
              >
                {t('notFound.back')}
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
    </GuestLayout>
  );
};

export default NotFound;
